var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedo20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6797 3.77417V7.35483H4.31761C2.47709 7.35483 1.86358 7.9516 1.86358 9.74193V16.9033H4.31761V14.5161C4.31761 12.7258 4.93111 12.129 6.77163 12.129H11.6797V15.7097L19.0417 9.74193L11.6797 3.77417Z",
    fill: "url(#paint0_linear_152_3299)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0661 2.5V6.75802H4.31753C3.36328 6.75802 2.53189 6.90503 1.96651 7.455C1.40113 8.00496 1.25 8.81368 1.25 9.74191V17.5H4.93104V14.5161C4.93104 13.654 5.08666 13.2692 5.28816 13.0732C5.48966 12.8772 5.88528 12.7258 6.77155 12.7258H11.0661V16.9838L20 9.74191L11.0661 2.5ZM18.0833 9.74191L12.2931 14.4355V11.5322H6.77155C5.81731 11.5322 4.98592 11.6792 4.42053 12.2292C3.85515 12.7792 3.70402 13.5879 3.70402 14.5161V16.3064H2.47701V9.74191C2.47701 8.8798 2.63264 8.49497 2.83414 8.29896C3.03564 8.10296 3.43126 7.95158 4.31753 7.95158H12.2931V5.04829L18.0833 9.74191Z",
    fill: "#222627"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_3299",
    x1: 10.4527,
    y1: 3.77417,
    x2: 10.4527,
    y2: 16.9033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BBC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo20);
export default __webpack_public_path__ + "static/media/redo_20.28a36b5026b11824c1fd633150e758ba.svg";
export { ForwardRef as ReactComponent };